<template>
    <div>
        <!-- informacion de quiniela -->
        <div class="card">
            <div class="card-body">
                <h3>Envío masivo para quiniela {{ quiniela.nombre }}</h3>
                <p>
                    {{ quiniela.torneo.nombre }}<br />{{ quiniela.tipo.nombre }}
                </p>
            </div>
        </div>

        <!-- importación de codigos -->
        <div class="card">
            <form method="post" enctype="multipart/form-data">
                <input type="hidden" :value="csrf" name="_token" />
                <div class="card-body">
                    <p>
                        Cargue un archivo de Excel con la siguiente estructura
                        para asignar los códigos. Debe llevar los títulos en la
                        primera fila. Los comentarios se guardan en los códigos
                        asignados.
                    </p>

                    <table class="table table-sm table-bordered">
                        <thead>
                            <tr>
                                <th class="text-center">A</th>
                                <th class="text-center">B</th>
                                <th class="text-center">C</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Nombre</td>
                                <td>Email</td>
                                <td>Comentarios</td>
                            </tr>
                        </tbody>
                    </table>
                    <br />

                    <div class="mb-4">
                        <input
                            type="file"
                            name="file"
                            v-on:change="file = true"
                        />
                    </div>
                </div>
                <div class="card-footer">
                    <button
                        type="submit"
                        class="btn btn-primary"
                        :disabled="file == null"
                    >
                        Importar
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    props: ["quiniela"],
    data() {
        return {
            file: null,
            csrf: $('meta[name="csrf-token"]').attr("content"),
        };
    },
};
</script>
